// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import logo from "../assets/logo.png";
// import "./Navbar.css"; // Replace with your logo image path
// import { useNavigate } from "react-router-dom";
// import { FaUser } from "react-icons/fa";
// import { useState, useEffect } from "react";
// import Cookies from "js-cookie";
// import { IoHomeOutline } from "react-icons/io5";

// const CustomNavbar = () => {
//   const [isMobile, setIsMobile] = useState(false);
//   const nav = useNavigate();
//   const [userType, setUserType] = useState();
//   const [phoneNumber, setPhoneNumber] = useState("");
  
//     useEffect(() => {
//       const interval = setInterval(() => {
//         const userType = Cookies.get('userType');
//         const phoneNo = Cookies.get('phoneNo');
//         setPhoneNumber(phoneNo)
  
//         if (userType !== undefined) {
//           setUserType(userType);
//           clearInterval(interval);
//         }
//       }, 100);
  
//       return () => clearInterval(interval);
//     }, []);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 767);
//     };

//     window.addEventListener("resize", handleResize);
//     handleResize(); // Initial check

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   const handleLogout = async () => {
//     const URI = userType == "lender" ? "logoutLender" : "logoutVendor";
//     const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/${URI}`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         },
//         body: JSON.stringify({number : phoneNumber}),
//     })
//     if(response.ok){
//       if(userType == "lender"){
//         Cookies.remove("jwtToken");
//         Cookies.remove("refreshToken");
//         Cookies.remove("phoneNo");
//         Cookies.remove("authStatus");
//         Cookies.remove("userType");
//         Cookies.remove("communityNO");
//         Cookies.remove("lenderInfo");
//         Cookies.remove("location");
//       }
//       else{
//         Cookies.remove("jwtToken");
//         Cookies.remove("refreshToken");
//         Cookies.remove("phoneNo");
//         Cookies.remove("authStatus");
//         Cookies.remove("userType");
//         Cookies.remove("sellerId");
//       }
//     }
//     nav("/")
//   }

//   return (
//     <nav
//       className="navbar navbar-expand-lg custom-navbar"
//       style={{
//         zIndex: "9999",
//         top: "0",
//         position: "sticky",
//         height: "60px",
//       }}
//     >
//       <a className="navbar-brand" href="#home">
//         <img
//           src={logo}
//           alt="logo"
//           className="logo-img"
//           onClick={() => nav("/Dashboard")}
//         />
//       </a>
//       <button
//         className="navbar-toggler"
//         type="button"
//         data-toggle="collapse"
//         data-target="#basic-navbar-nav"
//         aria-controls="basic-navbar-nav"
//         aria-expanded="false"
//         aria-label="Toggle navigation"
//       >
//         <span className="navbar-toggler-icon"></span>
//       </button>
//       <div className="collapse navbar-collapse" id="basic-navbar-nav">
//         <ul className="navbar-nav ml-auto nav-icon">
//           <li className="nav-item">
//             <a className="nav-link custom-navbtn" href="/dashboard">
//               <span> <IoHomeOutline/> Home</span>
//             </a>
//           </li>
//           <li
//             className="nav-item dropdown"
//             style={{
//               backgroundColor: "red",
//               color: "white",
//               borderRadius: "5px",
//               marginRight: "55px",
//               height: isMobile ? "40px" : "50px",
//               width: isMobile ? "30%" : "100px",
//               marginLeft: isMobile ? "70%" : "0%",
//               marginBottom: isMobile ? "10%" : "0%",
//             }}
//           >
//             <a
//               className="nav-link dropdown-toggle custom-navbtn"
//               style={{ backgroundColor: "red", color: "white", borderRadius: "10px" }}
//               href="#"
//               id="dropdown-basic"
//               role="button"
//               data-toggle="dropdown"
//               aria-haspopup="true"
//               aria-expanded="false"
//             >
//               <span>
//                 <FaUser color="white" /> User
//               </span>
//             </a>
//             <div
//               className="dropdown-menu"
//               aria-labelledby="dropdown-basic"
//               style={{ Color: "white", zIndexIndex: "9999" }}
//             >
//               <a
//                 className="dropdown-item"
//                 style={
//                   {
//                     // color: "white",
//                     // backgroundColor: "red",
//                     //   fontSize: "20px",
//                   }
//                 }
//                 onClick={handleLogout}
//               >
//                 Logout
//               </a>
//               {/* <a
//                 className="dropdown-item"
//                 style={
//                   {
//                     // color: "white",
//                     // backgroundColor: "red",
//                     //   fontSize: "20px",
//                   }
//                 }
//                 href="/EditPermissions"
//               >
//                 Permission
//               </a> */}
//             </div>
//           </li>
//         </ul>
//       </div>
//     </nav>
//   );
// };

// export default CustomNavbar;


import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Ensure Bootstrap JS is included
import logo from "../assets/logo.png";
import "./Navbar.css";
import { useNavigate, useLocation } from "react-router-dom";
import { FaUser, FaHome } from "react-icons/fa";
import { HiOutlineLogout } from "react-icons/hi";
import Cookies from "js-cookie";

const CustomNavbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const nav = useNavigate();
  const location = useLocation();
  const [userType, setUserType] = useState();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [activeLink, setActiveLink] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const userType = Cookies.get('adminUserType');
      const phoneNo = Cookies.get('adminPhoneNo');
      setPhoneNumber(phoneNo);

      if (userType !== undefined) {
        setUserType(userType);
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location]);

  const handleLogout = async () => {
    const URI = userType === "lender" ? "logoutLender" : userType === "dealer" ? "logoutVendor" : "logoutAdmin";
    const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/auth/${URI}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Full-URL": window.location.href, // Optional: full URL
      },
      credentials:"include",
      body: JSON.stringify({ number: phoneNumber }),
    });
    if (response.ok) {
      if (userType === "lender") {
        Cookies.remove("adminJwtToken");
        Cookies.remove("adminRefreshToken");
        Cookies.remove("adminPhoneNo");
        Cookies.remove("adminAuthStatus");
        Cookies.remove("adminUserType");
        Cookies.remove("adminCommunityNO");
        Cookies.remove("adminLenderInfo");
        Cookies.remove("adminLocation");
      } else {
        Cookies.remove("adminJwtToken");
        Cookies.remove("adminRefreshToken");
        Cookies.remove("adminPhoneNo");
        Cookies.remove("adminAuthStatus");
        Cookies.remove("adminUserType");
        Cookies.remove("adminSellerId");
      }
    }
    userType === "Master_Lender" ? nav("/masterLogin") : nav("/");
  };

  const handleNavigation = (path) => {
    nav(path);
  };

  return (
    <nav
      className="navbar navbar-expand-lg p-2"
      style={{ backgroundColor: "white", boxShadow: "2px 2px 7px rgb(147, 147, 147)", zIndex: "9999" }}
    >
      <div className="container-fluid bg-white">
        <div className="navbar-brand" onClick={() => {userType === "Master_Lender" ? handleNavigation("/manageZoneRegion") : handleNavigation("/dashboard")}} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="Company Logo" className="logo-img" />
        </div>
        <button className="navbar-toggler px-2 py-1" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" style={{backgroundImage: "var(--bs-navbar-toggler-icon-bg)"}}></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <div
                className={`nav-link ${activeLink === "/dashboard" ? "active" : ""}`}
                onClick={() => {userType === "Master_Lender" ? nav("/manageZoneRegion") : nav("/dashboard")}}
                style={{ cursor: 'pointer', fontWeight:"bold" }}
              >
                <FaHome className="nav-icon" /> Home
              </div>
            </li>
            <li className="nav-item ms-2">
              <div
                className={`nav-link`}
                onClick={handleLogout} style={{ cursor: 'pointer', fontWeight:"bold", color: "#ee373b"}}
              >
                Logout <HiOutlineLogout className="nav-icon" />
              </div>
            </li>
            {/* <li className="nav-item dropdown ms-2">
              <div
                className="nav-link dropdown-toggle"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                style={{fontWeight:"bold"}}
              >
                <FaUser className="nav-icon" /> User
              </div>
              <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <div className="dropdown-item" onClick={handleLogout} style={{ cursor: 'pointer' }}>
                  Logout
                </div>
              </div>
            </li> */}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default CustomNavbar;
